import React from 'react';
import { Helmet } from "react-helmet";
import { FaShieldAlt, FaUserLock, FaCoins, FaGlobe } from "react-icons/fa";

const AboutUs = () => {
    const domain = window.location.hostname;

    return (
        <div className="min-h-screen flex flex-col items-center py-6 px-3">
            <Helmet>
                <title>PRIVATE POLICY {domain}</title>
            </Helmet>

            <div className="w-full max-w-md">
                {/* Header */}
                <div className="text-center mb-4">
                    <h1 className="text-2xl font-bold text-indigo-600">FAQ & Privacy Policy</h1>
                    <p className="mt-1 text-gray-600 text-sm">Learn how {domain} protects your data and supports MMO safely</p>
                </div>

                {/* Sections */}
                <div className="space-y-3">
                    <Card icon={<FaShieldAlt className="text-indigo-500 text-lg" />} title="Privacy Policy">
                        <ul className="list-disc pl-5 space-y-1 text-gray-700 text-sm leading-tight">
                            <li>All user information is secured with end-to-end encryption.</li>
                            <li>We do not sell your information to third parties.</li>
                        </ul>
                    </Card>

                    <Card icon={<FaUserLock className="text-green-500 text-lg" />} title="Customer Information">
                        <ul className="list-disc pl-5 space-y-1 text-gray-700 text-sm leading-tight">
                            <li>App secures all user input information: phone, email, IP, text content.</li>
                            <li>Page access history is collected by Google AdSense & AdMob. Visit their official pages for details.</li>
                        </ul>
                    </Card>

                    <Card icon={<FaCoins className="text-yellow-500 text-lg" />} title="Regulations on Coins">
                        <ul className="list-disc pl-5 space-y-1 text-gray-700 text-sm leading-tight">
                            <li>Users donate to receive coins equivalent to donated value.</li>
                            <li>Donation is voluntary.</li>
                            <li>Coins cannot be converted back to money.</li>
                        </ul>
                    </Card>

                    <Card icon={<FaGlobe className="text-purple-500 text-lg" />} title="About MMO">
                        <ul className="list-disc pl-5 space-y-1 text-gray-700 text-sm leading-tight">
                            <li>{domain} supports users in MMO with tools, utilities, and resources for efficiency.</li>
                            <li>Focus on safe, legitimate MMO: content creation, affiliate marketing, automation, data analysis.</li>
                            <li>Mission: save time, reduce repetitive tasks, access accurate info for better workflow.</li>
                            <li>We do not encourage illegal earning activities or misleading financial methods.</li>
                        </ul>
                    </Card>
                </div>

                {/* Footer */}
                <div className="text-center mt-6 text-gray-500 text-xs">
                    &copy; {new Date().getFullYear()} {domain}. All rights reserved.
                </div>
            </div>
        </div>
    );
};

// Reusable Card Component
const Card = ({ icon, title, children }) => (
    <div className="bg-white rounded-xl shadow-sm p-3 hover:shadow-md transition-shadow duration-200">
        <div className="flex items-center mb-2 space-x-2">
            {icon}
            <h2 className="text-lg font-semibold text-gray-800">{title}</h2>
        </div>
        {children}
    </div>
);

export default AboutUs;
